enum ScanTypes {
  MESSAGE,
  SHIPMENT
}

export { ScanTypes }
